import { render } from "./selectGoods.vue?vue&type=template&id=5191c00c&scoped=true"
import script from "./selectGoods.vue?vue&type=script&lang=js"
export * from "./selectGoods.vue?vue&type=script&lang=js"

import "./selectGoods.vue?vue&type=style&index=0&id=5191c00c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5191c00c"]])

export default __exports__